import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';
import { generatePasswordResetLink } from '../../../../../../services/password-reset-link-generator';

import messages from '../../../messages';
import style from '../../../style.module.less';

export const UpdatePasswordForm = ({ username }) => {
  const passwordResetLink = generatePasswordResetLink(username);

  return (
    <>
      <Text textType={TextType.H4} value={messages.updatePasswordFormHeader} />
      <div className={style.form}>
        <Button className={style['submit-button']} href={passwordResetLink} target='_self' theme='secondary'>
          <FormattedMessage {...messages.changePasswordButton} />
        </Button>
      </div>
    </>
  );
};
